import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";
import { formatHandlerCode } from "../../../utils/namesFormater";
import { AllDataReportedPeriod } from "../../Consulting/shared/AllDataReportedPeriod";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: (params: { confirmedDate: Date }) => void;
  zipFilename: string;
  proposedDate?: string;
  handlerCode: string;
}

export const AylonConfirmationDialog: React.FC<Props> = ({
  open,
  onClose,
  onConfirm,
  zipFilename,
  proposedDate,
  handlerCode,
}) => {
  // ברירת המחדל של תקופת הדיווח נבחרת בתוך AllDataReportedPeriod עצמו: מנסה
  // קודם להתאים ל-proposedDate (שחולץ משם קובץ ה-ZIP), ורק אם היא לא קיימת
  // ברשימת התקופות מה-DB נופל חזרה לתקופה החדשה ביותר.
  const [confirmedDate, setConfirmedDate] = useState<string>(proposedDate || "");

  const handleConfirm = () => {
    if (confirmedDate) {
      onConfirm({ confirmedDate: new Date(confirmedDate) });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth dir="rtl">
      <DialogTitle sx={{ textAlign: "right" }}>
        אישור תאריך דיווח - איילון ביטוח - קובץ {zipFilename}
      </DialogTitle>
      <DialogContent sx={{ textAlign: "right" }}>
        <Box mb={2}>
          <Typography variant="body2" color="text.secondary" mb={0.5}>
            יצרן מטפל
          </Typography>
          <Typography variant="body1" fontWeight="bold">
            {formatHandlerCode(handlerCode)}
          </Typography>
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary" mb={0.5}>
            תקופת דיווח
          </Typography>
          <AllDataReportedPeriod
            showPolicyCount={false}
            preferredPeriod={proposedDate}
            onChange={(period) => setConfirmedDate(period)}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "flex-end" }}>
        <Button onClick={onClose}>ביטול</Button>
        <Button onClick={handleConfirm} variant="contained" color="primary" disabled={!confirmedDate}>
          אישור
        </Button>
      </DialogActions>
    </Dialog>
  );
};
